import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { UserLoginPreferencesInput } from '../domain/dtos/user-login-preferences-input'
import { AccountUserNotFound } from '../domain/errors/account-user-not-found'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

enum ErrorCode {
  ACCOUNT_USER_NOT_FOUND = 'bff-web-account::user-not-found',
}
export class PutUserLoginPreferences {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: UserLoginPreferencesInput): Promise<null> {
    const response = await this.httpClient.request({
      method: HttpMethod.PUT,
      url: `${Envs.BFF_WEB_URL}/user/save-user-login-preferences`,
      body: this.makeBody(input),
    })

    if (response.statusCode === HttpStatusCode.CREATED || response.statusCode === HttpStatusCode.OK) {
      return null
    }

    switch (response.data.errorCode) {
      case ErrorCode.ACCOUNT_USER_NOT_FOUND:
        throw new AccountUserNotFound()
      default:
        throw new GeneralError()
    }
  }

  private makeBody({ navigationTarget }: UserLoginPreferencesInput) {
    return {
      navigationTarget,
    }
  }
}
